declare global {
  interface Window {
    adsbygoogle: Array<Record<string, unknown>>;
  }
}

export function pushAd(): void {
  try {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  } catch {
    // Ad blocker or script not loaded — fail silently
  }
}

export function isAdSenseReady(): boolean {
  return typeof window.adsbygoogle !== 'undefined';
}
